import { defineMessages } from 'react-intl';

export default defineMessages({
  addEmployees: {
    id: "components.form.memberSelection.addEmployees",
    defaultMessage: "Add Employees",
  },
});
